var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRegisterEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0C6.71875 0 0 6.71875 0 15C0 23.2812 6.71875 30 15 30C23.2812 30 30 23.2812 30 15C30 6.71875 23.2812 0 15 0ZM22.7188 11.375L13.9062 20.2188C13.625 20.5 13.2188 20.6875 12.8125 20.6875C12.4062 20.6875 12 20.5312 11.7188 20.2188L7.28125 15.7812C6.65625 15.1562 6.65625 14.1875 7.28125 13.5625C7.90625 12.9375 8.875 12.9375 9.5 13.5625L12.8125 16.875L20.5312 9.15625C21.1562 8.53125 22.125 8.53125 22.75 9.15625C23.3438 9.78125 23.3438 10.75 22.7188 11.375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterEmail);
export default __webpack_public_path__ + "static/media/registerEmail.fbf72a24c3146e9966ce0493ecb1c08b.svg";
export { ForwardRef as ReactComponent };